import React from 'react';

const CSS = require('./PopoverFooter.module.scss');

interface PopoverFooterProps {
  onClear: (e) => void;
  onApply: (e) => void;
  extraContent?: React.ReactNode;
}

function PopoverFooter({ onClear, onApply, extraContent }: PopoverFooterProps) {
  return (
    <footer className={CSS.PopoverFooter}>
      <button className={CSS.ClearButton} onClick={onClear}>
        Clear
      </button>
      {extraContent && <div className={CSS.ExtraContent}>{extraContent}</div>}
      <button className={CSS.ApplyButton} onClick={onApply}>
        Apply
      </button>
    </footer>
  );
}

export default PopoverFooter;
